import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router';

import ProgressiveImage from 'spa/Components/ProgressiveImage';
import logo from 'spa/images/logo.svg';
import withI18n from 'spa/Components/Context/withI18n';

@withI18n
class LogoNew extends React.Component {
  render() {
    const {i18n} = this.context;
    const {props} = this;

    return (
      <Link to={`/${i18n.lc}/`}>
        <ProgressiveImage
          alt={i18n._x('Urban Logo', 'Footer logo alt message')}
          disableWebp
          lowResImg={logo}
          height="22"
          highResImg={logo}
          highResImg2x={logo}
          width="112"
          {...props}
        />
      </Link>
    );
  }
}

export default LogoNew;



// WEBPACK FOOTER //
// ./spa/Components/Footer/LogoNew.jsx